import * as Icons from "lucide-react";

// Resolves a module_master `icon` name (e.g. "Home", "Users") to its lucide
// icon component. Missing or unknown names fall back to HelpCircle.
export const getModuleIcon = (iconName) => {
  if (!iconName) return Icons.HelpCircle;
  const Icon = Icons[iconName];
  return Icon || Icons.HelpCircle;
};
